<template>
  <span :class="`text-center mt-${topMargin}`">
    <v-autocomplete
      :hide-details="true"
      :items="filteredActivePackList"
      :loading="loading"
      :dense="dense"
      :outlined="outlined"
      color="primary"
      data-cy="packDropdown"
      data-test="packDropdown"
      item-text="title"
      item-value="id"
      :label="label"
      v-model="selectedPackId"
    >
      <template v-slot:item="{ item }">
        <div class="py-1 packSelectorOption">
          {{ item.title }}
        </div>
      </template>
    </v-autocomplete>
  </span>
</template>

<script>
import { mapState } from "vuex";
export default {
  name: "packSelector",
  computed: {
    filteredActivePackList() {
      const filteredPackList = this.packList.filter(pack => {
        if (
          !pack.pilotParticipationList ||
          !pack.pilotParticipationList.length ||
          pack.pilotParticipationList.includes(this.loggedInUserServiceArea) ||
          this.isOchinUser
        ) {
          return pack;
        }
      });

      return filteredPackList;
    },
    packId() {
      return parseInt(this.$route.params.packId, 10);
    },
    ...mapState({
      isOchinUser: state => state.session.user.isOchinUser,
      loggedInUserServiceArea: state => state.session.user.serviceArea,
    }),
  },
  async created() {
    if (this.preselectRoutePack) {
      this.selectedPackId = this.packId;
    }
  },
  data() {
    return {
      selectedPackId: null,
    };
  },
  props: {
    dense: { type: Boolean, default: true },
    label: { type: String, default: "Pack" },
    loading: { required: true, type: Boolean },
    outlined: { type: Boolean, default: false },
    packList: { required: true, type: Array },
    preselectRoutePack: { type: Boolean, default: true },
    topMargin: {
      type: String,
      default: "3",
    },
  },
  watch: {
    selectedPackId(val) {
      if (!val) {
        return;
      }
      this.$emit("selectPack", val);
    },
  },
};
</script>

<style scoped>
.packSelectorOption {
  width: 40rem !important;
}
</style>
